import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-interview-analysis',
    templateUrl: './interview-analysis.component.html',
    styleUrl: './interview-analysis.component.css',
    standalone: false
})
export class InterviewAnalysisComponent {
  @Input() insights: any = {};
  
  activeMainTab: string = 'skills';
  activeCodeTab: string = 'overview';
  
  expandedSkillCategory: string = "" ;
  expandedSkills: Set<string> = new Set();
  expandedInterviewerTopics: Set<string> = new Set();
  expandedOverallSections: Set<string> = new Set();
  
  candidateCodeCollapsed: boolean = true;
  optimalCodeCollapsed: boolean = true;
  showFullTranscript: boolean = false;

  mainTabs = [
    { id: 'skills', label: 'Skill Assessment', icon: 'bar_chart' },
    { id: 'code', label: 'Code Analysis', icon: 'code' },
    { id: 'overall', label: 'Overall Analysis', icon: 'assessment' },
  ];

  codeTabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'comparison', label: 'Comparison' },
    { id: 'analysis', label: 'Analysis' },
    { id: 'feedback', label: 'Feedback' }
  ];

  get typedSkillsByCategory(): { key: string; value: any[] }[] {
    return Object.entries(this.skillsByCategory || {}).map(([key, value]) => ({
      key,
      value: value as any[],
    }));
  }

  get skillsByCategory() {
    if (!this.insights.candidate_analysis) return {};
    
    return this.insights.candidate_analysis.reduce((acc: any, skill: any) => {
      if (!acc[skill.category]) {
        acc[skill.category] = [];
      }
      acc[skill.category].push(skill);
      return acc;
    }, {});
  }

  get transcriptPreview() {
    const fullText = this.fullTranscript;
    if (fullText.length <= 300) {
      return fullText;
    }
    return fullText.substring(0, 300) + '...';
  }

  get fullTranscript() {
    return this.insights.interview_transcript || 'No transcript available';
  }

  getCategoryDisplayName(category: string): string {
    return category.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
  }

  getScoreColor(score: number): string {
    if (score >= 80) return 'score-excellent';
    if (score >= 60) return 'score-good';
    if (score >= 40) return 'score-fair';
    return 'score-poor';
  }

  toggleSkillCategory(category: string) {
    if (this.expandedSkillCategory == category){
      this.expandedSkillCategory = ""
    }
    else this.expandedSkillCategory = category
  }

  toggleSkill(skillName: string) {
    if (this.expandedSkills.has(skillName)) {
      this.expandedSkills.delete(skillName);
    } else {
      this.expandedSkills.add(skillName);
    }
  }

  toggleInterviewerTopic(topic: string) {
    if (this.expandedInterviewerTopics.has(topic)) {
      this.expandedInterviewerTopics.delete(topic);
    } else {
      this.expandedInterviewerTopics.add(topic);
    }
  }

  toggleOverallSection(section: string) {
    if (this.expandedOverallSections.has(section)) {
      this.expandedOverallSections.delete(section);
    } else {
      this.expandedOverallSections.add(section);
    }
  }

  toggleTranscript() {
    this.showFullTranscript = !this.showFullTranscript;
  }

  toggleCandidateCode() {
    this.candidateCodeCollapsed = !this.candidateCodeCollapsed;
  }

  toggleOptimalCode() {
    this.optimalCodeCollapsed = !this.optimalCodeCollapsed;
  }


  get hasCodeAnalysis(): boolean {
    return this.insights.code_analysis && Object.keys(this.insights.code_analysis).length > 0;
  }

  get interviewerTopics() {
    if (!this.insights.interviewer_analysis) return [];
    
    return [
      { key: 'talk_to_listen_ratio', label: 'Talk-to-Listen Ratio', icon: 'volume_up' },
      { key: 'interruptions', label: 'Interruptions', icon: 'pause_circle' },
      { key: 'timeliness', label: 'Timeliness', icon: 'schedule' },
      { key: 'tonality_analysis', label: 'Tonality Analysis', icon: 'sentiment_satisfied' },
      { key: 'interview_intelligence', label: 'Subject Knowledge', icon: 'psychology' },
      { key: 'candidate_experience', label: 'Candidate Experience', icon: 'star' },
      { key: 'final_assessment', label: 'Final Assessment', icon: 'task_alt' }
    ];
  }
}